const handledUserIds = new Set<number>()

export const isCreatorProfileOfferHandled = (userId: number): boolean => handledUserIds.has(userId)

export const markCreatorProfileOfferHandled = (userId: number): void => {
    handledUserIds.add(userId)
}
